import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import Axios from 'axios'
import { Notifications } from '../common/notification';
import { CARRIER_UPDATE, CARRIER_ADD } from '../../config/rest_endpoints';
import Switch from "react-switch";

class CarrierAdd extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User:getUser(),
            name:'',
            session: '',
            cps: '',
            prefix: null,
            status: true,
            holdTime:'',
            isLoad: false
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
    }

    toggleSwitch() {
        this.setState({ status: !this.state.status })
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    
    handleSubmit() {
        const { cps, session,name, status, prefix, holdTime } = this.state
     
        var payload =
            {
                "name": name,
                "cps": parseInt(cps),
                "sessions": parseInt(session),
                "holdTime": parseInt(holdTime),
                "prefix": prefix,
                "status": status
            }
        this.setState({ isLoad: true })
        var headers = { 'Authorization': "Bearer " + this.state.User.token }
        Axios.post(CARRIER_ADD, payload, { headers }).then(res => {
            if (res) {
                this.props.close()
                this.props.carrierListing()
                this.setState({ isLoad: false })
                Notifications.notify("Carriers updated successfully", "Created", "success")
            }
            else {
                Notifications.notify("failed carrier update", "Failed", "error")
            }
        }).catch(err => {
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            this.setState({ isLoad: false })
            Notifications.notify(msessage, "Failed", "error")
            this.props.close()
        })
    }

    render() {
        const { cps, session,prefix, holdTime,name } = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Name</label>
                            <input type="text" className="form-control" name="name" value={name} onChange={this.handleChange} placeholder="Enter carrier name" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Session</label>
                            <input type="number" className="form-control" name="session" value={session} onChange={this.handleChange} placeholder="Enter session" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>CPS</label>
                            <input type="number" className="form-control" name="cps" value={cps} onChange={this.handleChange} placeholder="Enter CPS" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Prefix</label>
                            <input type="text" className="form-control" name="prefix" value={prefix} onChange={this.handleChange} placeholder="e.g. 3353#" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Hold Time</label>
                            <input type="text" className="form-control" name="holdTime" value={holdTime} onChange={this.handleChange} placeholder="Enter hold time" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group" style={{marginTop:'4px'}}>
                            <label style={labelStyle}>Carrier Status</label>
                            <div style={{marginTop:'4px'}}>
                                <Switch onChange={this.toggleSwitch} checked={this.state.status} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.handleSubmit}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Add Carrier
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-file-plus"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
export default CarrierAdd